import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';
import { searchContext, userAppContext } from '../Context/Context';
import LoadingSpinner from '../global/Loader/LoaderSpinner';
import AdvancedSearchUtiles from '@/Components/AdvancedSearch/AdvancedSearchUtiles';
import RestrictedAccess from '@/Components/Modal/RestrictedAccess';

export default function AdvancedSearchPage() {
  const { isAuthenticated } = userAppContext();
  const { loading, error } = searchContext();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="error-message">An error occurred: {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>DISGENET: Advanced Search</title>
        <meta name="description" content="Advanced search tools for DISGENET." />
      </Helmet>
      <CommonHeader />
      <div className="p-4 advanced-research container-view">
        <div className="search-results-container">
          {isAuthenticated ? (
            <AdvancedSearchUtiles />
          ) : (
            <RestrictedAccess feature="advancedSearch" >
              <AdvancedSearchUtiles />
            </RestrictedAccess>
          )}
        </div>
      </div>
    </>
  );
}
